export default __webpack_public_path__ + "static/media/icon-route-arrow-right.4601295c.svg";